// src/redux/slices/adminApplicationPaginationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const adminApplicationPaginationSlice = createSlice({
  name: 'adminApplicationPagination',
  initialState: {
    currentPage: 1,
    listFilter: "assigned-me",
    sortBy: {
      column: "",
      desc: false
    },
    searchKey: "",
    selectedCustomFilter: null,
    customFilteredApplications: []
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    resetCurrentPage: (state) => {
      state.currentPage = 1;
    },
    setListFilter: (state, action) => {
      state.listFilter = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSearchKey: (state, action) => {
      state.searchKey = action.payload;
    },
    setSelectedCustomFilters: (state, action) => {
      state.selectedCustomFilter = action.payload;
    },
    setCustomFilteredApplications: (state, action) => {
      state.customFilteredApplications = action.payload;
    }
  }
});

export const {
  setCurrentPage,
  resetCurrentPage,
  setListFilter,
  setSortBy,
  setSearchKey,
  setSelectedCustomFilters,
  setCustomFilteredApplications
} = adminApplicationPaginationSlice.actions;

export default adminApplicationPaginationSlice;
